import React from "react";
import "../../App.css";
import { formatClassNames } from "../../helpers/util";
import "./ActionButtons.css";

export default function ActionButtons({children, className}){
	return <div className={formatClassNames("action-buttons", [className])} >{ children}</div>
}